import React from "react";
import { Helmet } from "react-helmet";
import { Link, Navigate, useParams } from "react-router-dom";
import { ArrowLeft, ArrowRight, CheckCircle } from "lucide-react";

import Footer from "./Footer";
import Header from "./Header";
import { mockData } from "../data/mock";

export default function PortfolioDetailPage() {
  const { slug } = useParams();
  const item = mockData.portfolioItems.find((entry) => entry.slug === slug);

  if (!item) {
    return <Navigate to="/#portfolio" replace />;
  }

  const canonicalUrl = `https://fold-web-agency.fr/portfolio/${item.slug}`;
  const metaDescription = `${item.title} : ${item.description}`;
  const caseStudyData = {
    "@context": "https://schema.org",
    "@type": "CreativeWork",
    name: item.title,
    description: item.description,
    creator: {
      "@type": "Organization",
      name: "Fold Web Agency",
      url: "https://fold-web-agency.fr/",
    },
  };

  return (
    <div className="min-h-screen" style={{ background: "var(--bg-page)" }}>
      <Helmet>
        <title>{item.title} | Réalisation Fold Web Agency</title>
        <meta name="description" content={metaDescription} />
        <link rel="canonical" href={canonicalUrl} />
        <meta property="og:title" content={`${item.title} | Fold Web Agency`} />
        <meta property="og:description" content={metaDescription} />
        <meta property="og:url" content={canonicalUrl} />
        <script type="application/ld+json">
          {JSON.stringify(caseStudyData)}
        </script>
      </Helmet>

      <Header />

      <main className="portfolio-detail-page">
        <section className="portfolio-detail-hero">
          <div className="container">
            <Link to="/#portfolio" className="portfolio-back-link">
              <ArrowLeft className="w-4 h-4" />
              Retour aux réalisations
            </Link>

            <div className="portfolio-detail-grid">
              <div>
                <p className="hero-announcement">Cas client</p>
                <h1 className="heading-hero">{item.title}</h1>
                <p className="body-large portfolio-detail-intro">
                  {item.description}
                </p>
                <div className="portfolio-tags">
                  {item.technologies.map((tech) => (
                    <span key={tech} className="caption bg-gray-100 px-2 py-1 rounded">
                      {tech}
                    </span>
                  ))}
                </div>
              </div>

              <div className="portfolio-detail-image">
                <img src={item.image} alt={`Aperçu du projet ${item.title}`} />
              </div>
            </div>
          </div>
        </section>

        <section className="section">
          <div className="container case-study-grid">
            <article className="seo-panel">
              <CheckCircle className="w-6 h-6 text-green-500 mb-4" />
              <h2 className="heading-2">Le besoin</h2>
              <p className="body-medium">{item.challenge}</p>
            </article>
            <article className="seo-panel">
              <CheckCircle className="w-6 h-6 text-green-500 mb-4" />
              <h2 className="heading-2">La solution</h2>
              <p className="body-medium">{item.solution}</p>
            </article>
            <article className="seo-panel">
              <CheckCircle className="w-6 h-6 text-green-500 mb-4" />
              <h2 className="heading-2">Le résultat</h2>
              <p className="body-medium">{item.result}</p>
            </article>
          </div>
        </section>

        <section className="section alt">
          <div className="container portfolio-cta">
            <h2 className="heading-1">Un projet similaire ?</h2>
            <p className="body-large">
              Parlons de votre site, de vos objectifs et de la meilleure façon de présenter votre activité.
            </p>
            <Link to="/#contact" className="btn-primary hover-scale">
              Demander un devis
              <ArrowRight className="w-4 h-4 ml-2" />
            </Link>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
